// extracted by mini-css-extract-plugin
export var skipNav = "index-module--skipNav--1iuE9";